export default __webpack_public_path__ + "static/media/stay-cozy.82288388.svg";